import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=bbbf769a&scoped=true&"
import script from "./HomePage.vue?vue&type=script&lang=ts&"
export * from "./HomePage.vue?vue&type=script&lang=ts&"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=bbbf769a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbf769a",
  null
  
)

export default component.exports